import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tap } from 'rxjs/operators';
import { UserService } from '../services/user.service';
import { MagicLinkSentSnackbarMessageComponent } from './magicLinkSentSnackbarMessage.component';

@Component({
    styles: [`
        .mat-dialog-title {
            text-align: center;
        }
    `],
    template: `
        <div mat-dialog-title>{{title}}</div>
        <div mat-dialog-content>
            <p style="text-align: center;">{{text}}</p>

            <div>            
                <mat-form-field fxFlex>
                    <input matInput placeholder="Your email" [formControl]="emailControl">
                    <mat-error *ngIf="emailControl.errors?.required">Email is required.</mat-error>
                    <mat-error *ngIf="emailControl.errors?.pattern">Email is not valid.</mat-error>    
                </mat-form-field>
            </div>

            <div>
                <span fxFlex></span>
                <button mat-raised-button color="primary" [disabled]="emailControl.invalid" (click)="sendMagicLink()">{{action}}</button>
                <span fxFlex></span>
            </div>
            <div style="padding-top: 9px;" *ngIf="isExisting">
                <span fxFlex></span>
                    <span style="padding-top: 9px;">No account?</span><button mat-button (click)="useNew()" color="primary" >Create One</button>
                <span fxFlex></span>
            </div>
            <div style="padding-top: 14px; font-size: 12px;">
                Select "{{button_reference_text}}" to agree to Attensa's <a target="_blank" href="https://attensa.com/terms">Terms of Service</a> and <a target="_blank" href="https://attensa.com/privacy">Privacy Policy</a>
            </div>
        </div>
    `
})
export class PublicSigninDialogComponent {
    emailControl: FormControl;
    isExisting: boolean;
    
    constructor(@Inject(MAT_DIALOG_DATA) public data: { isExisting: boolean },
                private snackbar: MatSnackBar,
                private dialogRef: MatDialogRef<PublicSigninDialogComponent>,
                private userService: UserService) {
        this.isExisting = data.isExisting;

        this.emailControl = new FormControl('', {
            validators: [
                Validators.required, 
                Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$')
            ]
        });
    }

    get title(): string {
        return this.isExisting ? 'Welcome back' : 'Welcome'; 
    }

    get text(): string {
        return this.isExisting ? 
               'Enter the email address associated with your account and select "Send Magic Link". Then check your email. Clicking on the link will sign you in.' : 
               'Enter your email address below and select "Join". Then check your email for a confirmation message. Clicking on the link in that message will sign you in.'; 
    }

    get button_reference_text(): string {
        return this.isExisting ?
               'Send Magic Link' :
               'Join';
    }

    get action(): string {
        return this.isExisting ? 'Send Magic Link' : 'Join';
    }
    
    useNew(): void {
        this.isExisting = false;
    }

    sendMagicLink(): void {
        this.userService.issuePublicCode(this.emailControl.value)
        .pipe(tap(() => this.snackbar.openFromComponent(MagicLinkSentSnackbarMessageComponent)))
        .subscribe(() => this.dialogRef.close());
    }
}